import { css } from "@emotion/react";
import { Title } from "@src/components";
import { useGetViewData } from "@src/hooks/queries/useCommodityProvision";
import { PaymentList } from "@src/interfaces/Commodity.interface";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProvisionForm, { ProductType } from "./ProvisionForm";
import { ProductDataType } from "./ProvisionUpdate";

const ProvisionView = () => {
    const productInitialState: ProductType = {
        no: 0,
        type: "",
        code: "",
        name: "",
        subs_group: "",
        subs_group_name: "",
        price_discount_display1: "",
        price_discount_display2: "",
        description: "",
        created_at: "",
        updated_at: "",
    };

    const productDataInitalState: ProductDataType = {
        no: 0,
        productNo: 0,
        // type: "",
        // code: "",
        name: "",
        // subs_group: "",
        // subs_group_name: "",
        // postbox_situation_code: "",
        // issue_type: null,
        // status: 0,
        comments: "",
        // created_by: 0,
        // updated_by: 0,
        // created_at: "",
        // updated_at: "",
    };
    const { id } = useParams();
    const [productList, setProductList] = useState<ProductType[]>([
        productInitialState,
    ]);

    const [productData, setProductData] = useState<ProductDataType>(
        productDataInitalState,
    );

    const tryGetViewData = async () => {
        const response = await useGetViewData(id);
        const data = response.data;
        setProductData(data);
    };

    useEffect(() => {
        tryGetViewData();
    }, []);

    return (
        <>
            <div css={detailStyle}>
                <Title title="상품 지급" />
                <ProvisionForm
                    type="view"
                    productList={productList}
                    setProductList={setProductList}
                    productData={productData}
                    setProductData={setProductData}
                />
            </div>
        </>
    );
};

export default ProvisionView;

const detailStyle = css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 40px;
    padding-top: 68px;
    gap: 20px;
`;
